import { Cancel } from '@material-ui/icons'
import { useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import {
  Create,
  CreateProps,
  ListButton,
  NumberInput,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { PrintLayoutDto } from '../../core/dto/print-layout.dto'
import FilteredReferenceInput from '../common/FilteredReferenceInput'
import { ResourceName } from '../../core/ResourceName'

export const validatePrinterLayout = (values: PrintLayoutDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  if (!values.width) {
    errors.name = 'ra.validation.required'
  }
  if (!values.height) {
    errors.name = 'ra.validation.required'
  }
  if (!values.backgroundImageId) {
    errors.name = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.print-layouts.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const PrintLayoutCreate = (props: CreateProps) => {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Create {...props} title={<CreateTitle />}>
      <SimpleForm
        redirect="show"
        validate={validatePrinterLayout}
        toolbar={<CreateToolbar />}
      >
        <TextInput source="name" isRequired />
        <NumberInput source="width" isRequired />
        <NumberInput source="height" isRequired />

        <FilteredReferenceInput
          source="backgroundImageId"
          reference={ResourceName.FILES}
          sort={{ field: 'name', order: 'ASC' }}
          perPage={smallScreen ? 5 : 15}
          filterSource="name"
          selectWithPaginationInputProps={{
            optionText: 'name',
            showFilter: true,
          }}
          filter={{
            fileExtension: '.jpg,.png,.jpeg,.bmp,.gif',
          }}
          isRequired
        />
      </SimpleForm>
    </Create>
  )
}
